// extracted by mini-css-extract-plugin
export default {"pageIntro":"MapsAndGraphs_pageIntro__by-u8","pageDescription":"MapsAndGraphs_pageDescription__8q9Uo","tabHeading":"MapsAndGraphs_tabHeading__c8WKy"};